import React from 'react';
export function Guarantee() {
  return <section className="bg-brand-bg text-brand-text px-4 py-10" data-id="element-61">
      <div className="max-w-xl mx-auto text-center" data-id="element-62">
        <h2 className="text-xl md:text-2xl font-black mb-4 text-yellow" data-id="element-63">
          🛡️ GARANTÍA TOTAL DE 7 DÍAS
        </h2>
        <p className="text-base font-bold text-white mb-3" data-id="element-64">
          Si no te convence, te devolvemos el 100% de tu dinero. Sin preguntas.
          Sin vueltas.
        </p>
        <p className="text-sm text-brand-muted leading-relaxed mb-3" data-id="element-65">
          Tenés 7 días completos para revisar todo el material sin ningún
          riesgo. Si por cualquier motivo no te convence, nos escribís y te
          hacemos el reembolso completo.
        </p>
        <p className="text-sm font-bold text-yellow" data-id="element-66">
          Tu inversión está 100% protegida.
        </p>
      </div>
    </section>;
}